import { formatCurrency } from '@/helpers/format';
import { IPriceDescription } from '@/types';
import { ArrowRightOutlined, CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
interface IGroupedDates {
  priceDetails: IPriceDescription,
  detailsFontSize: string;
  checkin?: string;
  checkout?: string;
  facility_24_extension: number;
  isParkingAt?: boolean
  isTestC?: boolean
}
export function getDateAndDays(
  priceDetails: IPriceDescription,
  checkin?: string,
  checkout?: string,
  facility_24_extension?: number,
) {
  const hoursDiff = checkin && checkout ? dayjs(checkout).diff(dayjs(checkin), 'hour') : 0;

  if (checkin && checkout && dayjs(checkin).isSame(dayjs(checkout), 'day')) {
    return {
      dateLabel: `${dayjs(checkin).format('MMM D')} (${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''})`,
      timeLabel: `${dayjs(checkin).format('h:mm A')} – ${dayjs(checkout).format('h:mm A')}`,
      daysLabel: `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''}`,
    };
  }


  return {
    dateLabel: `${dayjs(checkin).format('MMM D')} – ${dayjs(checkout).format('MMM D')} (${priceDetails?.daysParked} days)`,
    timeLabel: `${dayjs(checkin).format('h:mm A')} – ${dayjs(checkout).format('h:mm A')}`,
    daysLabel: `${priceDetails?.daysParked} days`,
  };
}

const NumberDays = ({
  priceDetails,
  detailsFontSize,
  checkin,
  checkout,
  facility_24_extension,
  isParkingAt,
  isTestC
}: IGroupedDates) => {
  const { dateLabel, timeLabel, daysLabel } = getDateAndDays(
    priceDetails,
    checkin,
    checkout,
    facility_24_extension
  );

  return (
    <>
      {isParkingAt ?
        <tr className={`${detailsFontSize}`}>
          <td>{dateLabel}</td>
        </tr>
        : isTestC ?
          <p className={`${detailsFontSize}`}>
            {dayjs(checkin).format('MMM D')} <ArrowRightOutlined className="text-sm" /> {dayjs(checkout).format('MMM D')} · {priceDetails?.daysParked} days
          </p>
          :
          <tr className={`${detailsFontSize} space-y-2`}>
            <div className="flex items-start gap-2.5">
              <CalendarOutlined className="text-secondary mt-0.5 shrink-0" style={{ fontSize: 16 }} />
              <div className="text-sm text-muted-foreground">
                <p>{dateLabel}</p>
                <p>{timeLabel}</p>
              </div>
            </div>
          </tr>
      }
    </>
  );
};

export default NumberDays;

